var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gene-set-cart-2kc" },
    [
      _c(
        "form",
        {
          staticClass: "gene-set-cart-2kc-search",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSearch.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "gene-set-cart-2kc-search-inner" }, [
            _c(
              "label",
              {
                staticClass: "gene-set-cart-2kc-label",
                attrs: { for: "gene-set-cart-2kc-genes" },
              },
              [_vm._v("Genes separated with comma")]
            ),
            _c("div", { staticClass: "gene-set-cart-2kc-search-row" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.geneInput,
                    expression: "geneInput",
                  },
                ],
                staticClass: "form-control gene-set-cart-2kc-input",
                attrs: {
                  id: "gene-set-cart-2kc-genes",
                  rows: "2",
                  placeholder: "Comma-separated gene symbols, e.g. APOE, LDLR",
                  disabled: _vm.status === "loading",
                },
                domProps: { value: _vm.geneInput },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.geneInput = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-cfde reveal-query-submit-btn gene-set-cart-2kc-submit",
                  attrs: {
                    type: "submit",
                    disabled: _vm.status === "loading" || !_vm.geneInputTrimmed,
                  },
                },
                [
                  _vm.status === "loading"
                    ? _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { small: "" },
                      })
                    : _vm._e(),
                  _vm._v(" Search "),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _vm.status === "error" && _vm.error
        ? _c(
            "b-alert",
            {
              staticClass: "mb-3 gene-set-cart-2kc-alert",
              attrs: { show: "", variant: "danger" },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _vm.status === "ready" && _vm.factorDataTableRows.length
        ? _c(
            "div",
            { staticClass: "gene-set-cart-2kc-results" },
            [
              _c("gene-set-cart-2-k-c-table", {
                attrs: {
                  rows: _vm.factorDataTableRows,
                  "row-count": _vm.factorDataTableRows.length,
                  "main-table-per-page": _vm.mainTablePerPage,
                  "main-table-current-page": _vm.mainTableCurrentPage,
                  "subtable-per-page": _vm.subtablePerPage,
                  "subtable-current-pages": _vm.subtableCurrentPages,
                  helpers: _vm.tableHelpers,
                },
                on: {
                  "download-raw-json": _vm.downloadRawJson,
                  "toggle-factor-row": _vm.toggleFactorRow,
                  "open-factor-connectivity": _vm.openFactorConnectivityPopup,
                  "update:mainTableCurrentPage": function ($event) {
                    _vm.mainTableCurrentPage = $event
                  },
                  "update:subtable-page": _vm.onSubtablePageUpdate,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            size: "xl",
            title: "Gene set cluster connectivity",
            "hide-footer": "",
            "body-class": "p-2",
          },
          model: {
            value: _vm.factorConnectivityPopupOpen,
            callback: function ($$v) {
              _vm.factorConnectivityPopupOpen = $$v
            },
            expression: "factorConnectivityPopupOpen",
          },
        },
        [
          _vm.factorConnectivityPopupRow
            ? _c("div", { staticClass: "small text-muted mb-2" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getFactorClusterDisplay(
                        _vm.factorConnectivityPopupRow
                      )
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm.factorConnectivityPopupNetwork &&
          _vm.factorConnectivityPopupNetwork.nodes.length
            ? _c("factor-base-reveal-network", {
                attrs: {
                  network: _vm.factorConnectivityPopupNetwork,
                  height: _vm.popupNetworkHeight,
                  "keep-physics-enabled": "",
                  "gene-node-metric-key": "gwas_support",
                  "gene-color-by-gwas-support": "",
                  "edge-distance-metric-key": "functional_support",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }